export enum ViewReportLabels {
    orderCreationDateRangeType = 'Fecha de creación de la orden',
    shipmentCreationDateRangeType = 'Fecha de creación del embarque'
}
